var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.loggedIn)?_c('HeaderPostLogin'):_c('HeaderContent'),(_vm.loggedIn)?_c('TabMenu',{attrs:{"active":1}}):_vm._e(),_c('HomeContent',{attrs:{"isMobile":false}}),_c('FooterContent')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }